import type { CSSProperties } from 'react'
import { cn } from '~/lib/utils'

/**
 * Icône SVG de maquette peinte en `currentColor` par un masque CSS : elle suit la couleur du texte
 * (onglets atténués au repos, pleins au survol, blancs une fois actifs ; icônes claires des
 * épingles de la carte). Un simple `<img>` garderait la couleur figée dans le SVG.
 */
export function MaskIcon({
  src,
  className,
  style,
}: {
  src: string
  className?: string
  style?: CSSProperties
}) {
  return (
    <span
      aria-hidden="true"
      className={cn('size-4 shrink-0 bg-current', className)}
      style={{ ...style, mask: `url("${src}") center / contain no-repeat` }}
    />
  )
}

/** Icône de maquette sous forme de composant, pour la prop `icon` d'`AppTab` (comme une icône lucide). */
export const maskIconOf = (src: string) =>
  function MaskIconComponent({ className }: { className?: string }) {
    return <MaskIcon src={src} className={className} />
  }
